import { PowerBILinkedService } from 'app/model/linkedservice/powerbi.linkedservice';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { WebActivityLinkedServiceAdapter } from './web-activity-linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PowerBILinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                authentication: '*',
                baseUrl: '*',
                username: '*',
                resource: '*',
                userTenant: '*',
                password: 'secret',
                pfx: 'secret',
                credential: '*',
                enableServerCertificateValidation: '*'
            },
            parameters: '*'
        }
    }
})
export class PowerBILinkedServiceAdapter extends WebActivityLinkedServiceAdapter {
    protected modelConstructor(): new () => PowerBILinkedService {
        return PowerBILinkedService;
    }

    protected model(): IModel {
        return PowerBILinkedService.MODEL;
    }
}
